import {BaseEntity,PrimaryColumn,PrimaryGeneratedColumn, UpdateDateColumn, CreateDateColumn, Entity, Column, VersionColumn} from "typeorm";
@Entity('spec_sheet')
export class SpecSheet{
    @PrimaryGeneratedColumn("increment",{name:'spec_sheet_id'})
    specSheetId:number;
    
    @Column("int",{
        nullable:false,
        name:"customer_id"
    })
    customerId:number

    @Column("int",{
        nullable:false,
       name:"brand_id"
    })
    brandId:number;

   @Column("int",{
    name:"sku_code_id",
    nullable:false
   })
   skuCodeId:number;

   @Column("varchar",{
    name:"file_name",
   })
   fileName:string;

   @Column("varchar",{
   name:"file_path"
   })
   filePath:string;

   @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;
  
   
@CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "created_user",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
    static multipleVarientCode: any;
}